import React from "react";

/**
 * Modal Component
 * ---------------
 * 
 * The modal components, is the main modal used across the app.
 * It is custom built on top of the Shadcn UI Dialog component.
 *
 * The modal has the following helpers:
 * - ModalContentWrapper (always wraps the content of the modal)
 * - ModalTopSection (optional: gives the ability to add a top section to the modal)
 * - ModalSidebar (optional: gives the ability to add a sidebar to the modal)
 *
 */

// prettier-ignore
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogOverlay  } from "../shadcn/dialog";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children?: React.ReactNode;
  closeWhenClickOutside?: boolean;
  showBlackOverlay?: boolean;
}

// prettier-ignore
export const Modal = ({ isOpen, onClose, title, description, children, closeWhenClickOutside = true, showBlackOverlay = true }: ModalProps) => {

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  const handleInteractOutside = (e: Event) => {
    if (!closeWhenClickOutside) {
      e.preventDefault(); 
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogOverlay 
        className="z-[999999]"
        backgroundClass={showBlackOverlay ? "bg-black/40" : "bg-transparent"}
      />
      <DialogContent
        className="max-h-[90vh] p-0 z-[9999999] flex flex-col"
        onInteractOutside={handleInteractOutside}
        aria-description=""
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader className="px-8 py-5 border-b flex-shrink-0">
          <DialogTitle className="text-lg font-semibold capitalize">{title}</DialogTitle>
          <DialogDescription className={`${description ? "text-sm" : "hidden"}`}>{description}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-1 min-h-0">
          
          <div 
            className="flex-1 overflow-y-auto"
            style={{
              scrollbarGutter: 'stable',
              overflow: 'overlay'
            }}
          >
            {children}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};


// Modal Layout Helpers
export const ModalContentWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="flex-1 p-8 pr-4 overflow-y-auto">
    {children}
  </div>
);


export const ModalTopSection = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div>{children}</div>;
};


export const ModalSidebar = ({ children }: { children: React.ReactNode }) => (
  <div className="w-64 flex-shrink-0 border-r">{children}</div>
);






